import {CategoryGroup} from "@/pages/pagespeed/report/body/structure/CategoryGroup.tsx";
import {PagespeedLHR} from "@/pages/pagespeed/types.ts";

interface StructureTabProps {
  lhr: PagespeedLHR;
}
export const StructureTab = ({lhr}: StructureTabProps) => {
  return (
    <>
      <CategoryGroup className="mt-3" lhr={lhr} categories={lhr.categories} title="Performance" name="performance" />
      <CategoryGroup className="mt-3" lhr={lhr} categories={lhr.categories} title="Guidelines" name="best-practices" />
      <CategoryGroup
        className="mt-3"
        lhr={lhr}
        categories={lhr.categories}
        title="Accessibility"
        name="accessibility"
      />
      <CategoryGroup className="mt-3" lhr={lhr} categories={lhr.categories} title="SEO" name="seo" />
      <CategoryGroup className="mt-3" lhr={lhr} categories={lhr.categories} title="Progressive Web Apps" name="pwa" />
    </>
  );
};
